var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"page-side-container"},[_c('div',{staticClass:"page-side-header"},[_vm._t("header")],2),_c('div',{staticClass:"divider"}),_c('div',{staticClass:"page-side-content"},[_vm._t("content")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }